<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15nRou8/tc-custom/9781635763485.jpg?1699984924090" alt="This image is the cover for the book Starcarbon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Starcarbon
      </h1>
      <p class="bookDescription body article font2">
        <b>Three couples struggle through tricky relationships in a novel “shot through with an offhand lyricism, snippets of wisdom, and a ready humor” (<i>Seattle Post-Intelligencer</i>).</b><br/><br/> After her first year in college, Olivia de Havilland Hand returns home to Tahlequah, Oklahoma, amid tornadoes and the chance for rekindled love. Meanwhile, in New Orleans, her half-sister Jessie tries to keep her new marriage to immature King afloat as she plans for the arrival of their first child. The sisters’ lives intertwine with others as their father fears losing his two daughters, and Olivia’s anthropology professor has a tumultuous affair with a fellow academic. An interconnected web of relationships thrives against the backdrop of a world in transition in this literary rumination on the joys and sorrows of family and love from the National Book Award-winning author.<br/><br/> “Gilchrist’s distinctive, flowing voice keeps one engaged throughout.” –<i>Kirkus Reviews</i><br/>  <br/> “Scattered from North Carolina to New Orleans, with outposts in Oklahoma and Boston, the Hands are forever bouncing up and down on the branches of the family tree to test its strength. As young members struggle for autonomy and older generations fight for control, alliances are formed, allegiances betrayed. And through it all, the Hands talk: to one another, to their psychiatrists, to themselves. In <i>Starcarbon</i>, Ms. Gilchrist has blended these resolutely individual voices to create a richly textured family fugue.”—<i>The New York Times</i><br/>  <br/> “Gilchrist's marvelous storytelling gifts are abundantly lavished on her new novel, which continues the saga of the Hand family and its intricate network of kinfolk.” –<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Gilchrist
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23ac0916